/*Auto-generated at pre-build.js*/ export class BuildDetails { public static readonly isoDate = '2026-10-21T23:35:10.287Z'; }